import styled from 'styled-components';

import { H2 } from '@r1-frontend/ui-react/components/typography/heading';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { BreakPointsMFirst } from '~/src/constants/breakpoints';
import { getReferenceDataArray } from '~/src/features/yandex-landing/utils';

import { Container } from '~/src/features/yandex-landing/styled';

export const ContainerCatalog = styled(Container)`
    width: 1362px;
    margin-bottom: 64px;
    box-sizing: content-box;
    padding: 0 90px;

    @media (max-width: ${breakPoints.sDesktop}) {
        width: 960px;
        padding: 0;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 640px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 304px;
        margin-bottom: 32px;
    }
`;

export const CatalogWrapper = styled.div`
    gap: 32px;

    @media (max-width: ${breakPoints.sDesktop}) {
        gap: 0;

        & > div:not(:first-child):not(:last-child) {
            padding-bottom: 64px;
        }
    }
`;

export const TitleCatalog = styled(H2)`
    text-align: center;
    ${FONTS.H1};

    @media (max-width: ${breakPoints.desktop}) {
        ${FONTS.H2};
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakPoints.mobile}) {
        white-space: pre;
    }
`;

export const SubtextCatalog = styled.div`
    ${FONTS.L};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.S};
    }
`;

export const TextCatalogWrapper = styled.div`
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    @media (max-width: ${breakPoints.sDesktop}) {
        margin-bottom: 32px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        align-items: flex-start;
        gap: 4px;
        margin-left: 8px;
    }
`;

export const CardsWrapper = styled.div<{ count: number }>`
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(${props => getReferenceDataArray(props.count).column[props.count]}, 1fr);
    grid-template-rows: repeat(${props => getReferenceDataArray(props.count).row[props.count]}, 1fr);

    @media (max-width: ${breakPoints.desktop}) {
        gap: 8px;
    }

    @media (min-width: ${BreakPointsMFirst.sDesktop}) and (max-width: ${breakPoints.desktop}) {
        gap: 2px;
    }
`;

export const YandexCard = styled.div`
    width: 304px;
    height: 350px;
`;
